import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Page } from "../components/Page";
import { ButtonDS } from "@qivia/ui/src/designSystem/components/Button";
import "../../i18n/i18n";

export const RestitutionCheckBeforeDeparturePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Page
      title={t("driverPayment.stateOfPlayBeforeDeparture")}
      returnButton
      returnButtonAction={() => navigate(-1)}
      bottomButton={
        <ButtonDS
          format="fill"
          buttonType="primary"
          text={t("restitution.button.validate")}
          onClick={() => console.log("todo")}
        />
      }
    />
  );
};
